import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { format, subDays } from "date-fns";
import { ReactComponent as ReadingGlasses } from "assets/common/common/readingGlasses.svg";
import { ReactComponent as ArrowBack } from "assets/common/common/arrowBack.svg";
import DayPickerInputMobile from "../../-components/common/DayPickerInputMobile";

const formatDate = (date?: Date) => (date ? format(date, "yyyy-MM-dd") : "");

const parseDateString = (str?: string | null): Date | undefined => {
    if (!str) return;
    const [y, m, d] = str.split("-").map(Number);
    if (!y || !m || !d) return;
    return new Date(y, m - 1, d);
};

const rangeOptions = [
    { label: "1주일", value: 7 },
    { label: "1개월", value: 30 },
    { label: "6개월", value: 182 },
    { label: "1년", value: 365 },
];

const MorningTrackingFilter = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // 조회 페이지에서 넘어온 현재 검색조건(쿼리스트링)을 초기값으로 사용
    const searchParams = new URLSearchParams(location.search);

    const [blNo, setBlNo] = useState(searchParams.get("blNo") ?? "");
    const [startDate, setStartDate] = useState<Date | undefined>(parseDateString(searchParams.get("startDate")));
    const [endDate, setEndDate] = useState<Date | undefined>(parseDateString(searchParams.get("endDate")));
    const [selectedRange, setSelectedRange] = useState<number | null>(null);

    const handleRangeClick = (days: number) => {
        setSelectedRange(days);
        const today = new Date();
        setStartDate(subDays(today, days));
        setEndDate(today);
    };

    const handleSearch = () => {
        if (startDate && endDate && startDate > endDate) {
            alert("시작일은 종료일보다 이후일 수 없습니다.");
            return;
        }

        // 기존 검색조건은 유지하고 날짜/운송장번호만 갱신
        const params = new URLSearchParams(location.search);
        const setOrDelete = (key: string, value: string) => {
            if (value) params.set(key, value);
            else params.delete(key);
        };

        setOrDelete("blNo", blNo);
        setOrDelete("startDate", formatDate(startDate));
        setOrDelete("endDate", formatDate(endDate));
        params.set("page", "1");
        params.set("pageSize", "10");

        navigate(`/customer/tracking?${params.toString()}`);
    };

    return (
        <div className="fixed inset-0 z-[500] bg-white flex flex-col min-h-[100dvh] max-h-[100dvh] overflow-hidden">
            <div className="flex gap-2 border-b border-[#E1E2E4] min-h-[60px] items-center px-[4%]">
                <button type="button" className="flex" onClick={() => navigate(-1)}>
                    <ArrowBack />
                    <span className="indent-[-9999em] absolute">닫기</span>
                </button>
                <input
                    type="text"
                    className="flex-1 border-box"
                    placeholder="(숫자9자리만 넣어주세요(-XXX 제외)"
                    value={blNo}
                    onChange={e => setBlNo(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === "Enter") handleSearch();
                    }}
                />
                <figure>
                    <button type="button" onClick={handleSearch}>
                        <ReadingGlasses />
                        <span className="indent-[-9999em] absolute">검색</span>
                    </button>
                </figure>
            </div>
            <div className="flex-1 overflow-auto px-[4%] flex flex-col pb-[10px]">
                <div className="py-3 flex flex-col justify-center items-center gap-[8px]">
                    <p className="text-[#878A93] text-[14px] mb-[8px] w-full">접수일자</p>
                    <div className="flex flex-1 w-full border font-[500] border-new rounded-lg min-h-[50px] overflow-hidden">
                        {rangeOptions.map(({ label, value }, idx) => (
                            <button
                                key={value}
                                className={`flex-1 border-new ${idx < rangeOptions.length - 1 ? "border-r" : ""} ${
                                    selectedRange === value ? "bg-new text-white" : "text-[#1b1c1e]"
                                }`}
                                onClick={() => handleRangeClick(value)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                    <div className="flex flex-1 w-full gap-3 relative bg-white h-[52px] px-3 border border-[#E1E2E4] rounded-lg">
                        <DayPickerInputMobile
                            initialDate={startDate}
                            twoCalendar
                            onDateChange={date => {
                                setSelectedRange(null);
                                setStartDate(date);
                            }}
                        />
                        <DayPickerInputMobile
                            initialDate={endDate}
                            twoCalendar
                            onDateChange={date => {
                                setSelectedRange(null);
                                setEndDate(date);
                            }}
                        />
                    </div>
                </div>
                <button
                    type="button"
                    className="text-white bg-[#132E47] text-center py-[12px] w-full text-[20px] rounded-lg mt-[8px]"
                    onClick={handleSearch}
                >
                    검색
                </button>
            </div>
        </div>
    );
};

export default MorningTrackingFilter;
